import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PaginationState {
  page: number;
  rowsPerPage: number;
}

const initialState: PaginationState = {
  page: 0,
  rowsPerPage: 10
};

const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setRowsPerPage(state, action: PayloadAction<number>) {
      state.rowsPerPage = action.payload;
      state.page = 0; // reset page when rowsPerPage changes
    },
    resetPagination(state) {
      state.page = 0;
      state.rowsPerPage = 10;
    }
  }
});

export const { setPage, setRowsPerPage, resetPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
